import { render, staticRenderFns } from "./PreviousExports.vue?vue&type=template&id=4fcb175d&"
import script from "./PreviousExports.vue?vue&type=script&lang=ts&"
export * from "./PreviousExports.vue?vue&type=script&lang=ts&"
import style0 from "./PreviousExports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcb175d')) {
      api.createRecord('4fcb175d', component.options)
    } else {
      api.reload('4fcb175d', component.options)
    }
    module.hot.accept("./PreviousExports.vue?vue&type=template&id=4fcb175d&", function () {
      api.rerender('4fcb175d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/export/PreviousExports.vue"
export default component.exports